import React from 'react';
import Form, { AlertSeverity } from 'components/Form';
import Joi from 'joi';
import { withTranslation } from 'react-i18next';
import emailService from 'services/emailService';

import { Box } from '@mui/material';

interface FormData {
  name: string;
  email: string;
  subject: string;
  message: string;
}

const emptyData = (): FormData => ({
  name: '',
  email: '',
  subject: '',
  message: '',
});

class EmailForm extends Form {
  state = {
    data: emptyData(),
    errors: emptyData(),
    submitted: false,
    submitSuccess: false,
  };

  schema = {
    name: Joi.string()
      .allow(null, '')
      .label(this.props.t('contacts.nameLabel')),
    email: Joi.string()
      .email({ tlds: { allow: false } })
      .required()
      .label(this.props.t('contacts.emailLabel')),
    subject: Joi.string()
      .required()
      .label(this.props.t('contacts.subjectLabel')),
    message: Joi.string()
      .required()
      .label(this.props.t('contacts.messageLabel')),
  };

  doSubmit = async () => {
    const { name, email, subject, message } = this.state.data;
    const response = await emailService.send(name, email, subject, message);
    this.setState({
      submitted: true,
      submitSuccess: response,
      data: {
        name: '',
        email: '',
        subject: '',
        message: '',
      },
    });
  };

  render() {
    const { t } = this.props;

    return (
      <Box
        component='form'
        sx={{
          '& .MuiTextField-root': { m: 1, width: { xs: 0.8, md: 0.5 } },
        }}
        noValidate
        autoComplete='off'
        onSubmit={this.handleSubmit}
      >
        {this.renderInput(
          'name',
          t('contacts.nameLabel'),
          undefined,
          undefined,
          false
        )}
        {this.renderInput('email', t('contacts.emailLabel'))}
        {this.renderInput('subject', t('contacts.subjectLabel'))}
        {this.renderInput('message', t('contacts.messageLabel'), 6, true)}
        {this.renderButton('Send')}
        {this.state.submitted
          ? this.state.submitSuccess
            ? this.renderAlert(
                t('contacts.successMessage'),
                AlertSeverity.Success
              )
            : this.renderAlert(t('contacts.errorMessage'), AlertSeverity.Error)
          : null}
      </Box>
    );
  }
}

export default withTranslation()(EmailForm);
